// Import model
import { StartContactAppointmentInitiateOmwsmsRequest } from '../models/StartContactAppointmentInitiateOmwsmsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartContactAppointmentInitiateOmwsmsRequest - handles JSON serialization and deserialization with type validation
 */
export class StartContactAppointmentInitiateOmwsmsRequestSerializer {
  /**
   * Deserializes a JSON string into a StartContactAppointmentInitiateOmwsmsRequest instance
   */
  static deserialize(json: string): StartContactAppointmentInitiateOmwsmsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartContactAppointmentInitiateOmwsmsRequest instance
   */
  static fromObject(obj: any): StartContactAppointmentInitiateOmwsmsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartContactAppointmentInitiateOmwsmsRequest');
    }


    const instance: StartContactAppointmentInitiateOmwsmsRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartContactAppointmentInitiateOmwsmsRequest instances
   */
  static deserializeArray(json: string): StartContactAppointmentInitiateOmwsmsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartContactAppointmentInitiateOmwsmsRequest instance to a JSON string
   */
  static serialize(instance: StartContactAppointmentInitiateOmwsmsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartContactAppointmentInitiateOmwsmsRequest instance to a plain object
   */
  static toObject(instance: StartContactAppointmentInitiateOmwsmsRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartContactAppointmentInitiateOmwsmsRequest instances to a JSON string
   */
  static serializeArray(instances: StartContactAppointmentInitiateOmwsmsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
